import { z } from 'zod';

/**
 * Certificate of Insurance (COI) form - Carrier + Policy Number only.
 *
 * Both fields are required per spec. Alphanumeric is sufficient; we
 * don't restrict character set here because insurance carriers and
 * policy numbers vary widely in real-world format.
 */
export const CertificateOfInsuranceSchema = z.object({
    Carrier: z.string().trim().min(1, 'Carrier is required'),
    PolicyNumber: z.string().trim().min(1, 'Policy Number is required'),
});

export type CertificateOfInsuranceFormViewModel = z.infer<typeof CertificateOfInsuranceSchema>;

export const emptyCertificateOfInsuranceFormViewModel: CertificateOfInsuranceFormViewModel = {
    Carrier: '',
    PolicyNumber: '',
};
